export const queryKey = {
    groups: () => ['groups'],
};
